// extracted by mini-css-extract-plugin
module.exports = {"videosItem":"BitaPreviewVideo_videosItem__cY3On","videosImage":"BitaPreviewVideo_videosImage__jaA8C","videosDescription":"BitaPreviewVideo_videosDescription__2YVfE"};